import { type ReactNode, type CSSProperties, type DragEvent } from 'react';

interface CardProps {
  children: ReactNode;
  drillable?: boolean;
  padding?: number;
  onClick?: () => void;
  style?: CSSProperties;
  draggable?: boolean;
  onDragStart?: (e: DragEvent) => void;
  onDragOver?: (e: DragEvent) => void;
  onDrop?: (e: DragEvent) => void;
  onDragEnd?: (e: DragEvent) => void;
}

export function Card({ children, drillable = false, padding = 22, onClick, style, draggable, onDragStart, onDragOver, onDrop, onDragEnd }: CardProps) {
  return (
    <div
      onClick={onClick}
      draggable={draggable}
      onDragStart={onDragStart}
      onDragOver={onDragOver}
      onDrop={onDrop}
      onDragEnd={onDragEnd}
      style={{
        background: 'var(--card)',
        border: `1px solid ${drillable ? 'rgba(210,58,59,0.2)' : 'var(--card-border)'}`,
        borderRadius: 'var(--radius-card)',
        padding,
        boxShadow: 'var(--card-shadow)',
        position: 'relative',
        cursor: onClick ? 'pointer' : undefined,
        transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
        ...style,
      }}
    >
      {drillable && (
        <svg
          width="10"
          height="10"
          viewBox="0 0 10 10"
          style={{ position: 'absolute', top: 12, right: 12, opacity: 0.45 }}
        >
          <path
            d="M3.5 2L7 5L3.5 8"
            fill="none"
            stroke="var(--accent)"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {children}
    </div>
  );
}
